import { en } from './en';
import { ga } from './ga';

export { en, ga };

export const resources = {
  en,
  ga,
} as const;
